export const STATUS_WITH_PAGE = [
  "REJECTED",
  "ON_COUNCIL",
  "ON_AGREEMENT",
  "ON_COMMITTEE",
  "ON_LOCAL_COUNCIL"
]

export const BREADCRUMB_HOME_BY_STATUS = {
  REJECTED: "Solicitudes rechazadas",
  ON_AGREEMENT: "Solicitudes en convenio",
  ON_COMMITTEE: "Solicitudes en comité técnico",
  ON_COUNCIL: "Solicitudes en consejo directivo",
  ON_LOCAL_COUNCIL: "Solicitudes en consejo local"
}